<template lang="pug">
.table-pagination-wrapper
    .pagination
        .button.button-prev(:class='{ "is-disabled": isPreviousButtonDisabled }', @click='onLoadPage("previous")') &#60;

        .paginationTrigger-trigger
            .trigger(@click='onLoadPage(1)', :class='{ "is-active": currentPage === 1 }') 1

            template(v-if='displayArrowLeft')
                .previous-step(v-if='!hoverLeft', @mouseover='hoverLeft = true')
                    svg-icon(name='dots', size='small')
                .previous-step(v-else, @click='onLoadPage("previousStep")', @mouseleave='hoverLeft = false') &#60;&#60;
                //-   svg-icon(name="arrow_left", size="small")

            .trigger(
                v-for='paginationTrigger in paginationTriggers',
                :key='paginationTrigger',
                @click='onLoadPage(paginationTrigger)',
                :class='{ "is-active": paginationTrigger === currentPage }'
            ) {{ paginationTrigger }}

            template(v-if='_displayArrowRight')
                .next-step(v-if='!hoverRight', @mouseover='hoverRight = true')
                    svg-icon(name='dots', size='small')
                .next-step(v-else, @click='onLoadPage("nextStep")', @mouseleave='hoverRight = false') &#62;&#62;
                    //- svg-icon(name='arrow_right', size='small')

            .trigger(v-if='displayLastPage', @click='onLoadPage(totalPages)', :class='{ "is-active": currentPage === totalPages }') {{ totalPages }}
        .button.button-next(:class='{ "is-disabled": isNextButtonDisabled }', @click='onLoadPage("next")') &#62;

    .table-size
        div show
        select.select-table-size(@change='handleItemsPerPage')
            option(v-for="items of itemsPerPageList" :value="items") {{ items }}
        div /page
</template>

<script>
export default {
    props: {
        currentPage: { type: Number, required: true },
        totalPages: { type: Number, required: true },
        visiblePages: { type: Number, default: 7 },
        itemsPerPageList: { type: Array, required: true },
    },

    mounted() {
        this.visiblePagesThreshold = this.isOdd(this.visiblePages)
            ? (this.visiblePages - 1) / 2
            : this.visiblePages / 2
        if (this.totalPages > 0) this.setArrows(this.currentPage, this.totalPages)
    },

    watch: {
        currentPage: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.setArrows(newVal, this.totalPages)
            }
        },
        totalPages: function(newVal, oldVal) {
            //- this watcher instead of mounted (totalPages === 0 in mounted)
            if (newVal !== oldVal) {
                this.setArrows(this.currentPage, newVal)
            }
        },
    },
    data() {
        return {
            displayArrowRight: false,
            displayArrowLeft: false,
            hoverRight: false,
            hoverLeft: false,
            visiblePagesThreshold: null,
        }
    },
    computed: {
        _displayArrowRight() {
            return (
                this.displayArrowRight &&
                this.paginationTriggers[this.paginationTriggers.length - 1] < this.totalPages - 1
            )
        },
        isPreviousButtonDisabled() {
            return this.currentPage === 1
        },
        isNextButtonDisabled() {
            return this.totalPages === 0 || this.currentPage === this.totalPages
        },
        displayLastPage() {
            return this.totalPages > 1
        },
        paginationTriggers() {
            const { currentPage, totalPages, visiblePages, visiblePagesThreshold } = this
            const paginationTriggers = []

            if (totalPages <= visiblePages) {
                // If less or equal than totalPages page, display everything
                for (let i = 1; i < totalPages - 1; i++) {
                    paginationTriggers.push(i + 1)
                }
            } else if (totalPages > visiblePages) {
                // If total pages are more than visiblePages ==> check currentPage to know which pages to display
                if (currentPage <= visiblePagesThreshold + 1) {
                    // -- if currentPage is close to 1st page
                    for (let i = 1; i <= visiblePagesThreshold + 2; i++) {
                        paginationTriggers.push(i + 1)
                    }
                } else if (currentPage >= totalPages - visiblePagesThreshold + 1) {
                    // -- if currentPage is close to last page
                    for (let i = totalPages - 1; i > totalPages - visiblePages + 1; i--) {
                        paginationTriggers.push(i)
                    }
                    paginationTriggers.reverse()
                } else if (
                    currentPage > visiblePagesThreshold + 1 &&
                    currentPage < totalPages - visiblePagesThreshold + 1
                ) {
                    // -- currentPage is between 1st and last page
                    // fill "middle" array with pages numbers
                    for (let i = 0; i < visiblePages - 2; i++) {
                        paginationTriggers.push(currentPage - visiblePagesThreshold + 1 + i)
                    }
                }
            }
            return paginationTriggers
        },
    },
    methods: {
        onLoadPage(value) {
            let _value
            const { totalPages, visiblePagesThreshold, paginationTriggers } = this
            const _middleArrayLastValue = paginationTriggers[paginationTriggers.length - 1]
            if (value === 'next') {
                _value = this.currentPage + 1
            } else if (value === 'previous') {
                _value = this.currentPage - 1
            } else if (value === 'nextStep') {
                if (_middleArrayLastValue >= totalPages - visiblePagesThreshold + 1) {
                    _value = totalPages
                } else {
                    _value = this.currentPage + visiblePagesThreshold + 1
                }
            } else if (value === 'previousStep') {
                if (_middleArrayLastValue <= visiblePagesThreshold + 1) {
                    _value = 1
                } else {
                    _value = this.currentPage - visiblePagesThreshold - 1
                }
            } else {
                _value = value
            }
            this.$emit('loadPage', _value)
        },
        handleItemsPerPage(event) {
            this.$emit('itemsPerPage', parseInt(event.target.value))
        },
        isOdd(num) {
            return num % 2 === 1
        },
        setArrows(currentPage, totalPages) {
            if (totalPages > this.visiblePages) {
                if (currentPage <= this.visiblePagesThreshold + 1) {
                    this.displayArrowLeft = false
                    this.displayArrowRight = true
                } else if (currentPage >= totalPages - this.visiblePagesThreshold + 1) {
                    this.displayArrowRight = false
                    this.displayArrowLeft = true
                } else if (
                    currentPage > this.visiblePagesThreshold + 1 &&
                    currentPage < totalPages - this.visiblePagesThreshold + 1
                ) {
                    this.displayArrowRight = true
                    this.displayArrowLeft = true
                }
            } else {
                this.displayArrowLeft = false
                this.displayArrowRight = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.table-pagination-wrapper {
    display: flex;
    align-items: center;

    padding: 16px;

    height: 70px;
    font-size: 14px;
}

.pagination {
    display: flex;
    align-items: center;

    margin: 0 auto;
}

.paginationTrigger-trigger {
    display: flex;
    align-items: center;
}

.table-size {
    display: flex;
    align-items: center;

    padding: 0 4px;
    font-size: 12px;
}

.select-table-size {
    margin: 4px;
    border: 1px solid #cdcdcd;
    border-radius: 4px;
    padding: 4px 8px;
    width: 40px;
    text-align: right;
}

.previous-step,
.next-step {
    width: 16px;
    text-align: center;
    cursor: pointer;
}

.trigger {
    padding: 6px 12px;
    margin: 0 4px;
    cursor: pointer;
    font-size: 12px;
}

//- Style BIF FISH 🐳
// .trigger {
//     opacity: 0.8;
//     color: black;

//     &.is-active,
//     &:hover {
//         color: #fe4277;
//     }
// }
// .previous-step,
// .next-step {
//     opacity: 0.8;
//     color: black;
//     &:hover {
//         color: #fe4277;
//     }
// }
</style>
